/**
 * PWA 업데이트 배너 — 새 버전 감지 시 상단에 "새 버전이 나왔어요 [업데이트]" 표시.
 * 버튼 클릭 → 대기중 서비스워커에 SKIP_WAITING → controllerchange → 자동 새로고침.
 * (캐시 수동 삭제 불필요. 안 누르면 기존 버전 유지 — 강제 아님)
 *
 * index.js 의 serviceWorkerRegistration.register({onUpdate}) 가
 * window 'sw-update-available' 이벤트를 발생시키면 이 배너가 뜬다.
 */
import React, { useState, useEffect } from "react";

export default function UpdateBanner() {
  const [show, setShow] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const onAvail = () => setShow(true);
    window.addEventListener("sw-update-available", onAvail);
    // 마운트 시 이미 대기중 SW 가 잡혀 있으면 즉시 표시
    if (window.__swRegistration && window.__swRegistration.waiting)
      setShow(true);
    return () => window.removeEventListener("sw-update-available", onAvail);
  }, []);

  const doUpdate = () => {
    setUpdating(true);
    const reg = window.__swRegistration;
    const waiting = reg && reg.waiting;
    if (waiting && navigator.serviceWorker) {
      let reloaded = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });
      waiting.postMessage({ type: "SKIP_WAITING" });
      // 안전망: controllerchange 가 안 와도 3초 후 강제 새로고침
      setTimeout(() => {
        if (!reloaded) {
          reloaded = true;
          window.location.reload();
        }
      }, 3000);
    } else {
      window.location.reload();
    }
  };

  if (!show) return null;

  return (
    <div style={wrap} role="status" aria-live="polite">
      <span style={dot} />
      <span style={msg}>
        새 버전이 나왔어요.{" "}
        <span style={{ color: "rgba(255,255,255,0.7)" }}>
          업데이트하면 최신 화면으로 바뀝니다.
        </span>
      </span>
      <button style={btn} onClick={doUpdate} disabled={updating}>
        {updating ? "적용 중…" : "업데이트"}
      </button>
      <button
        style={closeBtn}
        onClick={() => setShow(false)}
        title="나중에"
        aria-label="나중에"
      >
        ✕
      </button>
    </div>
  );
}

const wrap = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 2147483000, // 최상단(모든 패널 위)
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "9px 14px",
  background: "#1a1b1e",
  color: "#fff",
  fontSize: 13.5,
  fontFamily:
    "'Malgun Gothic', '맑은 고딕', 'Pretendard Variable', Pretendard, -apple-system, 'Apple SD Gothic Neo', sans-serif",
  boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
  paddingTop: "calc(9px + env(safe-area-inset-top))",
};
const dot = {
  flexShrink: 0,
  width: 8,
  height: 8,
  borderRadius: "50%",
  background: "#34d399",
  boxShadow: "0 0 0 3px rgba(52,211,153,0.25)",
};
const msg = { flex: 1, minWidth: 0, lineHeight: 1.4 };
const btn = {
  flexShrink: 0,
  border: "none",
  borderRadius: 7,
  padding: "7px 16px",
  background: "#1a73e8",
  color: "#fff",
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: "inherit",
};
const closeBtn = {
  flexShrink: 0,
  border: "none",
  background: "transparent",
  color: "rgba(255,255,255,0.6)",
  fontSize: 14,
  cursor: "pointer",
  padding: "4px 6px",
  lineHeight: 1,
};
